(function () {
  const MQ = window.matchMedia("(max-width: 1024px)");

  function buildDropdownFromSubnav(subnavEl, level) {
    const list = subnavEl?.querySelector("ul.sub-nav-list");
    if (!list) return null;

    const ul = document.createElement("ul");
    ul.className = "dropdown-submenu";
    ul.dataset.level = String(level || 1);

    list.querySelectorAll(":scope > li.sub-nav-item").forEach((li) => {
      const a = li.querySelector(":scope > a.sub-nav-item-link");
      if (!a) return;

      const newLi = document.createElement("li");
      const newA = a.cloneNode(true);
      newLi.appendChild(newA);

      // Support 3rd level too (optional)
      const btn = li.querySelector(":scope > button.open-sub-nav[aria-controls]");
      if (btn) {
        const controls = btn.getAttribute("aria-controls");
        if (controls) {
          const nestedSubnav = document.getElementById(controls);
          const nested = buildDropdownFromSubnav(nestedSubnav, (level || 1) + 1);
          if (nested) newLi.appendChild(nested);
        }
      }

      ul.appendChild(newLi);
    });

    return ul;
  }

  function toggleDropdownForButton(btn) {
    const controlsId = btn.getAttribute("aria-controls");
    const parentLi = btn.closest("li.nav-item, li.sub-nav-item");
    if (!controlsId || !parentLi) return;

    const existing = parentLi.querySelector(":scope > ul.dropdown-submenu");
    if (existing) {
      const isHidden = existing.style.display === "none";
      existing.style.display = isHidden ? "" : "none";
      parentLi.classList.toggle("is-expanded", isHidden);
      return;
    }

    const subnavEl = document.getElementById(controlsId);
    const dropdown = buildDropdownFromSubnav(subnavEl, 1);
    if (!dropdown) return;

    parentLi.appendChild(dropdown);
    parentLi.classList.add("is-expanded");
  }

  function init() {
    const mobileNav = document.getElementById("mobile-nav");
    if (!mobileNav) return;

    // Capture-phase listener to BLOCK theme's slider behavior
    mobileNav.addEventListener(
      "click",
      function (e) {
        if (!MQ.matches) return;

        const btn = e.target.closest("button.open-sub-nav[aria-controls]");
        if (!btn || !mobileNav.contains(btn)) return;

        // hard-stop original theme click handlers
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        toggleDropdownForButton(btn);
      },
      true // <-- CAPTURE PHASE (important)
    );
  }

  document.addEventListener("DOMContentLoaded", init);
})();
